import React from "react";
import FormikInput from "../../../../Components/Formik/FormikInput";
import FormikSelect from "../../../../Components/Formik/FormikSelect";
import { useFormikContext } from "formik";
import { useLanguage } from "../../../../Components/LangTranslation/LanguageContext";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { checkApi } from "../../../../DataApi/onboarding/checkApi";

function CreateWebsiteStep({
  countriesOption,
  statesOption,
  onChangeCountry,
  onChangeGovernate,
  governateOption,
  onChangeWilayat,
  cityOption,
  areaOption,
  onChangeCity,

  wilayatOption
}) {
  const { setFieldValue } = useFormikContext();
  const { language, translations } = useLanguage();
  const t = translations[language];
  return (
    <>
      <div className="my-3 col-md-4 col-12">
        <FormikSelect
          name="country"
          onChange={(option) => {
            onChangeCountry(option.value);
            setFieldValue("phone_prefix", option.phone_code || "");
            // setFieldValue("phone", option.phone || "");
          }}
          options={countriesOption}
          placeholder={t["Country"]}
          data-tooltip-id="countryTooltip"
          data-tooltip-content={t["Country"] + "*"}
        />
        <ReactTooltip id="countryTooltip" type="dark" effect="solid" />
      </div>
      <div className="my-3 col-md-4 col-12">
        <FormikSelect
          name="governate"
          onChange={(option) => {
            onChangeGovernate(option.value, "governate");
            // setFieldValue("zip", option.zip || "");
          }}
          options={governateOption}
          placeholder={t["Governorate"]}
          data-tooltip-id="governateTooltip"
          data-tooltip-content={t["Governorate"]}
        />
        <ReactTooltip id="governateTooltip" type="dark" effect="solid" />
      </div>
      <div className="my-3 col-md-4 col-12">
        <FormikSelect
          name="wilayat"
          onChange={(option) => {
            onChangeWilayat(option.value, "wilayat");
            // setFieldValue("zipB", option.zip || "");
          }}
          options={wilayatOption}
          placeholder={t["Wilayat"]}
          data-tooltip-id="wilayatTooltip"
          data-tooltip-content={t["Wilayat"]}
        />
        <ReactTooltip id="wilayatTooltip" type="dark" effect="solid" />
      </div>
      {/* <div className="my-3 col-md-4 col-12">
        <FormikSelect
          name="state"
          onChange={(option) => {
            setFieldValue("zip", option.zip || "");
          }}
          options={statesOption}
          placeholder={t["State"]}
          data-tooltip-id="stateTooltip"
          data-tooltip-content={t["State"] + "*"}
        />
        <ReactTooltip id="stateTooltip" type="dark" effect="solid" />
      </div> */}
      {/* <div className="my-3 col-md-4 col-12">
        <FormikInput
          name="city"
          placeholder={t["City"]}
          data-tooltip-id="cityTooltip"
          data-tooltip-content={t["City"] + "*"}
        />
        <ReactTooltip id="cityTooltip" type="dark" effect="solid" />
      </div> */}

      <div className="my-3 col-md-4 col-12">
        <FormikSelect
          name="city"
          onChange={(option) => {
            onChangeCity(option.value, "city");
            // setFieldValue("zipB", option.zip || "");
          }}
          options={cityOption}
          placeholder={t["City"]}
          data-tooltip-id="cityTooltip"
          data-tooltip-content={t["City"] + "*"}
        />
        <ReactTooltip id="cityTooltip" type="dark" effect="solid" />
      </div>
      <div className="my-3 col-md-4 col-12">
        <FormikSelect
          name="area"
          onChange={(option) => {
            checkApi({
              endpoint: "/onboarding/zip",
              params: {
                area_id: option.value,
              },
            }).then((zip) => {
              if (zip?.result?.result?.length > 0) {
                const zipOp = zip?.result?.result?.map((item) => ({
                  label: item.name,
                  value: item.id,
                }));
                // console.log("zipOp", zipOp);
                setFieldValue("zip", zipOp?.[0].label || "");
              }
            });
          }}
          options={areaOption}
          placeholder={t["Area"]}
          data-tooltip-id="areaTooltip"
          data-tooltip-content={t["Area"] + "*"}
        />
        <ReactTooltip id="areaTooltip" type="dark" effect="solid" />
      </div>
      <div className="my-3 col-md-4 col-12">
        <FormikInput
          name="street"
          placeholder={t["Street"]}
          data-tooltip-id="streetTooltip"
          data-tooltip-content={t["Street"] + "*"}
        />
        <ReactTooltip id="streetTooltip" type="dark" effect="solid" />
      </div>
      <div className="my-3 col-md-6 col-12">
        <FormikInput
          disabled={true}
          name="zip"
          placeholder={t["Zip Code"]}
          data-tooltip-id="zipTooltip"
          data-tooltip-content={t["Zip Code"] + "*"}
        />
        <ReactTooltip id="zipTooltip" type="dark" effect="solid" />
      </div>
      <div className="my-3 col-md-6 col-12 d-flex">
        <FormikInput name="phone_prefix" readOnly />
        <div className="d-flex flex-column w-100">
          <FormikInput
            name="phone"
            type="number"
            placeholder={t["Phone Number"]}
            data-tooltip-id="phoneTooltip"
            data-tooltip-content={t["Phone Number"] + "*"}
          />
          <ReactTooltip id="phoneTooltip" type="dark" effect="solid" />
        </div>
      </div>
    </>
  );
}

export default CreateWebsiteStep;
